import * as React from 'react';
import { connect } from 'react-redux';
import { fetchPublicacion, editPublicacion } from '../../../../actions/publicacionesActions';
import { updatePosicionesImagenesApi } from '../../../../api/axios';
import { createImageUrl } from '../../../../api/axios';
import { toast } from 'react-toastify';
import DrawAndDrop from './DrawAndDropImages';
const reorder = (list, startIndex, endIndex) => {
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
}


class Imagenes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            srcImg: "",
            showImg: false,
            imagenes: [],
            changeImages: true,
            sizeImages: this.props?.publicacion?.imagenes?.length,
        }
    }

    componentDidMount() {
        if (!this.state.imagenes.length) {
            this.setState({ imagenes: this.props.publicacion.imagenes });
        }
    }

    showImgModal = (e, src) => {
        e.preventDefault();
        this.setState({ showImg: true, srcImg: src });
    }

    hideImgModal = () => {
        this.setState({ showImg: false });
    }

    addImg = async (e) => {
        let sizeImg = this.checkImageSize();
        if (sizeImg > 500) {
            toast.error("Tamaño de imagen superior a 500kb");
            return;
        } else {
            //Subir imagen
            const image = e.target.files[0];
            let req = createImageUrl(image);
            let posicion = this.state.sizeImages + 1;

            req.then(res => {
                if (res != "") {
                    let newImage = { urlImagen: res.url, posicion: posicion };
                    this.state.imagenes.push(newImage);
                    const imagenes = reorder(this.state.imagenes);
                    this.setState({ imagenes: imagenes });
                    this.clearImgInput();
                    this.setState({
                        changeImages: false,
                        sizeImages: this.state.imagenes.length
                    });
                    this.props.publicacion.imagenes = this.state.imagenes;
                } else {
                    toast.error(res)
                }
            }).catch(error =>
                console.log()
            );
        }
    }

    deleteImg = (index, imgs,) => {
        imgs.splice(index, 1);
        const imagenes = reorder(imgs);
        this.setState({
            imagenes: imagenes,
            changeImages: false,
            sizeImages: this.state.imagenes.length
        });
    }

    checkImageSize = () => {
        var fileUpload = document.getElementById("imgInput");
        if (typeof (fileUpload.files) != "undefined") {
            var size = parseFloat(fileUpload.files[0].size / 1024).toFixed(2);
            return size;
        }
    }

    myChangeHandler = (event) => {
        let publicacion = { ...this.props.publicacion };
        publicacion[event.target.name] = event.target.value;
        this.props.editPublicacion(publicacion);
    }

    onReorderImagenes = () => {
        let imagenes = [];
        this.state.imagenes.map(function (img, index) {
            let posicion = index + 1;
            imagenes.push({ idImagen: img.idImagen, posicion: posicion });
        });

        let payload = { idPublicacion: this.props.publicacion.idPublicacion, imagenes: imagenes };
        const req = updatePosicionesImagenesApi(payload);

        req.then(res => {
            console.log(res);
            toast.success("Imagenes reordenadas, el cambio se verá reflejado a la brevedad");
        }).catch(err => {
            (err.response.data.errores)
            ? err.response.data.errores.forEach(error => toast.error(error))
            : toast.error("No pudo editarse");
        });
    }

    clearImgInput = () => {
        let inputImg = document.getElementById("imgInput");
        inputImg.value = null;
    }


    render() {
        return (
            <div>
                <DrawAndDrop />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    publicacion: state.publicaciones.publicacion,
});

export default connect(mapStateToProps, { fetchPublicacion, editPublicacion })(Imagenes);